<template>
  <div id="rg-date-input-dialog">
    <vs-prompt
      class="rg-date-input"
      title="再生履歴の日時設定"
      accept-text="設定"
      cancel-text="キャンセル"
      :active="active"
      is-valid="true"
      @accept="onAccept"
      @cancel="onCancel"
    >
      <div class="input-form">
        <div class="rg-date-time-input-notes aisea-text-12-400-gray">
          指定した表示エリアと日時から3時間の履歴を表示します。
        </div>
        <!-- 🔽 表示エリア選択 -->
        <div class="mb-6">
          <label class="aisea-text-14-400-gray block mb-2">表示エリア</label>
          <v-select
            v-model="selectedArea"
            :options="displayAreaOptions"
            :clearable="false"
            :closeOnSelect="true"
            :searchable="false"
            label="name"
            class="w-full"
          >
            <template v-slot:no-options>表示エリアが見つかりません。</template>
          </v-select>
        </div>

        <!-- 🔽 日時選択 -->
        <div class="mb-4">
          <label class="aisea-text-14-400-gray block mb-2">日時</label>
          <v-date-picker
            v-model="inputDatetime"
            :min-date="minDate"
            :max-date="maxDate"
            :minute-increment="10"
            mode="dateTime"
            :masks="masks"
            is-required
            is-expanded
            is24hr
          />
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import moment from "moment-timezone";
import vSelect from "vue-select";

const createOneHourAgoDateCalculator = () => {
  const momentNow = moment(); // createOneHourAgoDateCalculatorの呼び出し時の日時を基準にする
  return () => {
    return moment({
      year: momentNow.year(),
      month: momentNow.month(),
      day: momentNow.date(),
      hour: momentNow.hours(),
      minute: momentNow.minutes(),
    })
      .subtract(1, "hours")
      .toDate();
  };
};
const oneHourAgoDateCalculator = createOneHourAgoDateCalculator();
export default {
  name: "RgDateInputDialog",
  components: {
    vSelect,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    displayAreas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      minDate: moment({
        year: 2023,
        month: 4,
        day: 1,
        hour: 0,
        minute: 0,
      }).toDate(),
      maxDate: oneHourAgoDateCalculator(),
      inputDatetime: oneHourAgoDateCalculator(),
      masks: {
        title: "YYYY年 MMM",
      },
      selectedArea: null,
    };
  },

  watch: {
    displayAreas(newVal) {
      if (newVal.length > 0 && !this.selectedArea) {
        this.selectedArea = newVal[0];
      }
    },
  },

  computed: {
    displayAreaOptions() {
      return this.displayAreas || [];
    },
  },

  methods: {
    onAccept() {
      setTimeout(() => {
        this.$emit("sendInputValue", {
          datetime: this.inputDatetime,
          displayArea: this.selectedArea,
        });
      });
    },

    onCancel() {
      setTimeout(() => {
        this.$emit("onCancel");
      }, 50);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.rg-date-input {
  .vs-con-input-label {
    width: inherit;
  }

  .rg-date-time-input-notes {
    margin-bottom: 20px;
  }

  .vs-dialog-cancel {
    display: none;
  }
}
</style>
